import Vue from "vue";

export class CaixaSwitch {
    static create() {
        return {
            pacpon: {
                _id: null,
                numero: null
            },
            gerenciavel: false,
            onu_mac: null,
            vlan: null,
            place: [0, 0],
            numero: null,
            nome: null
        };
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixa-switch/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byPacPon(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixas-switch/by-pacpon/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static excluir(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("caixa-switch/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixas-switch")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("caixa-switch/" + data._id, data);
            } else {
                promisse = Vue.http.post("caixa-switch/0", data);
            }

            promisse.then(res => resolve(res.data), err => reject(err));
        });
    }
}
